module.exports = __webpack_public_path__ + "img/right-static-desktop.10f5145.webp";